import { listeCarteImageNomMock, stickerTexteMock, texteSeoMock, titreDescriptionMock } from '@mock/schema/components';
import { pushContenusMock } from '@mock/schema/components/push-contenus.mock';
import { pageBase } from '@mock/schema/slugs/config';
import { SlugPage } from '@pages/slug-page/models';

const blocks = [
  titreDescriptionMock(),
  listeCarteImageNomMock('cuisine-sur-mesure', true),
  stickerTexteMock(),
  pushContenusMock('cuisine-sur-mesure'),
  texteSeoMock('gray'),
];

export const cuisineSurMesureMock: SlugPage = {
  ...pageBase({
    title: 'Cuisine Sur Mesure',
    type: 'cuisine-sur-mesure',
    language: 'fr-FR',
    headerId: 'header-fr',
    footerId: 'footer-fr',
    isBreadcrumbOverlay: false,
  }),
  blocks,
};
